import { Component, inject, signal, effect, computed } from '@angular/core';
import { ChatbotComponent } from '@components';
import { ChatService } from '@api-services';
import { AuthenticationService } from '../../../../services/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChatDto } from '@api-contracts';

@Component({
  selector: 'wun-messages',
  imports: [CommonModule, FormsModule, ChatbotComponent],
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.scss'
})
export class MessagesComponent {
  private readonly chatService = inject(ChatService);
  private readonly authService = inject(AuthenticationService);
  
  chats = signal<ChatDto[]>([]);
  selectedChat = signal<ChatDto | null>(null);
  currentUserId = computed(() => {
    const user = this.authService.current();
    return user ? user.id : undefined;
  })
  isLoading = signal(false);
  isContactingAdmin = signal(false);
  adminMessageText = signal('');

  constructor() {
    effect(() => {
      const user = this.currentUserId();
      if (user) {
        this.loadChats();
      }
    })
  }

  loadChats() {
    this.isLoading.set(true);
    this.chatService.chatsFindAndPaginate({
      includes: JSON.stringify(['messages', 'fromUser', 'toUser']),
      sorting: JSON.stringify({ updatedAt: 'DESC' })
    }).subscribe({
      next: (response) => {
        this.chats.set(response.data || []);
        this.isLoading.set(false);
        if (response.data && response.data.length > 0 && !this.selectedChat()) {
          this.selectChat(response.data[0]);
        }
      },
      error: (err) => {
        console.error('Errore caricamento chat:', err);
        this.isLoading.set(false);
      }
    });
  }

  selectChat(chat: ChatDto) {
    this.selectedChat.set(chat);
  }

  getChatName(chat: ChatDto): string {
    const currentId = this.currentUserId();
    const otherUser = chat.fromUser.id === currentId ? chat.toUser : chat.fromUser;
    return otherUser.username ? `${otherUser.username} (${otherUser.profileType})` : `${otherUser.firstName} ${otherUser.lastName} (${otherUser.profileType})`;
  }

  contactAdmin() {
    const text = this.adminMessageText().trim();
    if (!text) return;

    this.isContactingAdmin.set(true);

    this.chatService.chatsSendMessageToAdmin({
      sendMessageToAdminDto: { text }
    }).subscribe({
      next: (chat) => {
        this.adminMessageText.set('');
        this.isContactingAdmin.set(false);
        this.loadChats();
        this.selectChat(chat);
      },
      error: (err) => {
        console.error('Errore contatto admin:', err);
        this.isContactingAdmin.set(false);
      }
    });
  }
}
